import * as preact from "preact";
import PropTypes from "prop-types";

import FormField from "../FormField";
import Checkbox from "../../Checkbox";

import "./style.css";

function CheckboxFormField(props) {
    const {
        label,
        labelWidth,
        title,
        checked,
        disabled,
        description,
        onChange
    } = props;

    return (
        <FormField
            class="checkboxFormField"
            label={label}
            labelWidth={labelWidth}
            disabled={disabled}>
            <label class="checkboxContainer">
                <Checkbox checked={checked} onChange={onChange} disabled={disabled}/>
                <div class="checkboxTitle">{title}</div>
            </label>
            <div class="checkboxDescription">{description}</div>
        </FormField>
    );
}

CheckboxFormField.propTypes = {
    label: PropTypes.string,
    title: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};

export default CheckboxFormField;
